// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-text-wrapper[data-v-7c547b04] {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.contact-name-block .fio[data-v-7c547b04] {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.contact-name-block .official[data-v-7c547b04] {
  height: 14px;
  width: 14px;
  border-radius: 8px;
  background-color: var(--icon-bgcolor2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 10px;
  margin-left: 5px !important;
  flex-basis: 14px;
  min-width: 14px;
  min-height: 14px;
  overflow: hidden;
}
.sub-text[data-v-7c547b04] {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.header-text .header-back[data-v-7c547b04] {
  margin-right: 12px;
}
.btn-custom[data-v-7c547b04] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-custom i.fa-window-maximize[data-v-7c547b04] {
  font-size: inherit;
  margin-left: unset;
}
.btn-custom i.fa-phone[data-v-7c547b04] {
  font-size: 0.96em;
  margin-left: unset;
}
.btn-custom[data-v-7c547b04]:hover {
  color: var(--toolbtn-color-hover) !important;
}
.btn-custom.menu[data-v-7c547b04] {
  width: 1.14em;
}
.header-chat-search[data-v-7c547b04] {
  color: var(--toolbtn-color);
}
.header-chat-search[data-v-7c547b04]:before {
  content: "\\F002";
  font-family: "Font Awesome 5 Pro";
}
.header-chat-search[data-v-7c547b04]:hover {
  color: var(--toolbtn-color-hover) !important;
}
svg[data-v-7c547b04]:hover {
  fill: var(--toolbtn-color-hover);
}
.disabled[data-v-7c547b04] {
  cursor: initial;
  filter: opacity(0.5) grayscale(1);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/main/header/MainHeaderContact.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;AACf;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,iCAAiC;AACnC","sourcesContent":[".contact-text-wrapper[data-v-7c547b04] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.contact-name-block .fio[data-v-7c547b04] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.contact-name-block .official[data-v-7c547b04] {\n  height: 14px;\n  width: 14px;\n  border-radius: 8px;\n  background-color: var(--icon-bgcolor2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n  font-size: 10px;\n  margin-left: 5px !important;\n  flex-basis: 14px;\n  min-width: 14px;\n  min-height: 14px;\n  overflow: hidden;\n}\n.sub-text[data-v-7c547b04] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.header-text .header-back[data-v-7c547b04] {\n  margin-right: 12px;\n}\n.btn-custom[data-v-7c547b04] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.btn-custom i.fa-window-maximize[data-v-7c547b04] {\n  font-size: inherit;\n  margin-left: unset;\n}\n.btn-custom i.fa-phone[data-v-7c547b04] {\n  font-size: 0.96em;\n  margin-left: unset;\n}\n.btn-custom[data-v-7c547b04]:hover {\n  color: var(--toolbtn-color-hover) !important;\n}\n.btn-custom.menu[data-v-7c547b04] {\n  width: 1.14em;\n}\n.header-chat-search[data-v-7c547b04] {\n  color: var(--toolbtn-color);\n}\n.header-chat-search[data-v-7c547b04]:before {\n  content: \"\\F002\";\n  font-family: \"Font Awesome 5 Pro\";\n}\n.header-chat-search[data-v-7c547b04]:hover {\n  color: var(--toolbtn-color-hover) !important;\n}\nsvg[data-v-7c547b04]:hover {\n  fill: var(--toolbtn-color-hover);\n}\n.disabled[data-v-7c547b04] {\n  cursor: initial;\n  filter: opacity(0.5) grayscale(1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
